import { z } from 'zod';
import type { ChatDto } from '../types/ChatDto';

export const chatDtoSchema = z.object({
  id: z.string().uuid(),
  status: z.enum(['pending', 'open', 'closed']).default('pending').optional(),
  subject: z.string().min(4).max(255),
  creatorId: z.string().uuid(),
  adminId: z.string().uuid().nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  deletedAt: z.string().datetime({ offset: true }).nullable(),
}) as z.ZodType<ChatDto>;
